<template>
  <section class="main-content" @keydown.esc="hideSingleView" tabindex="0">
    <MainBanner banner="Wir.Team" />
    <script type="application/ld+json" v-if="!singleViewOn">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Über uns",
        "item": "https://ito-consult.de/wir"
      },{
        "@type": "ListItem",
        "position": 3,
        "name": "Team",
        "item": "https://ito-consult.de/wir/team"
      }]
    }
  </script>
    <section class="block-content">
        <div class="container my-md-5 py-md-5">
                <div class="row my-md-5 py-md-5 align-items-center" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
                    <div class="col-12 col-md-5 my-4 mb-md-0">
                        <div class="img-container">
                            <img class="img-fluid" width="540" height="360" :alt="ito_team_image.title" :title="ito_team_image.title"  :src="generateThumbnail(ito_team_image.data.asset_url,540,360,50,'contain')" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 offset-md-1">
                        <article v-html="team_content"></article>
                        <router-link title="Jobs bei ito" :to="{name: 'jobs'}" class="btn btn-outline-ito hover-red animated-arrow mt-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                            </svg>
                            Komm ins Team!
                        </router-link>
                    </div>
                </div>
            </div>
    </section>

    <section class="block-content mb-5">
        <div class="container text-center my-5 py-5 px-5" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="0">
            <h2>Wir stellen uns vor...</h2>
            <div class="row g-4 my-md-5 mx-lg-5">
                <div class="col-12 col-sm-6 col-lg-4" v-for="(human, index) in employees" :key="human.id" data-aos="fade-up" data-aos-duration="400"  :data-aos-delay="index%3*100">
                    <router-link stay="true" :to="{name: 'ito.team.single', params: {id : human.slug}}" class="teammate" :title="'Mehr zu unserem Teammember ' + human.firstname" @click.native="singleViewOn=true">
                        <span class="image avatar mb-2">
                          <img width="478" height="318" :title="human.firstname +' '+human.lastname" :alt="'Profilbild von ' + human.firstname" class="img-fluid img_bw" :src="generateThumbnail(human.image_avatar.data.asset_url,478,318,60,'contain')" />
                          <img width="478" height="318" :title="human.firstname +' '+human.lastname" :alt="'Profilbild von ' + human.firstname" v-if="human.image_avatar_rgb" class="img-fluid img_rgb" :src="generateThumbnail(human.image_avatar_rgb.data.asset_url,478,318,60,'contain')" />
                        </span>
                        <span class="name">
                            <strong>{{human.firstname}}</strong><br>
                            <small>{{human.job}}</small>
                        </span>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <section  class="block-content" data-bg="grey" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="0">
        <div class="container text-center my-5 py-5">
            <blockquote class="py-5">Viele Ideen wachsen besser, wenn man sie in ein anderes Hirn umpflanzt, als sie in dem zu belassen, aus welchem sie stammen.
                <span class="author mt-3 d-block">Oliver Wendell Holmes</span>
            </blockquote>
        </div>
    </section>

    <section class="block-content"  data-aos="fade-up" data-aos-duration="1500" data-aos-offset="0">
        <div class="container text-center my-md-5 py-md-5">
            <h2>Events by ito</h2>
            <div class="images-wrapper row my-5">
              <div
                class="col-12 col-sm-6 col-md-4 mb-3" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100" :data-aos-delay="imageIndex*50"
                v-for="(event, imageIndex) in events"
                :key="imageIndex"
                @click="index = imageIndex">
                <div class="event-image">
                  <img width="500" height="350" class="img-fluid" :src="generateThumbnail(event.image.data.asset_url,500,350,60,'crop')" :title="event.image.title" :alt="'Bild vom Event ' + event.image.title" />
                </div>
              </div>
            </div>
          </div>
    </section>
    <div id="teammembersingle" @click="hideSingleView" :class="{'focus' : singleViewOn}"  class="d-md-flex justify-content-md-center align-items-lg-center">
        <router-view></router-view>
    </div>
    <CoolLightBox
      v-if="event_images"
      :items="event_images"
      :index="index"
      @close="index = null">
    </CoolLightBox>
  </section>
</template>

<script>

import axios from 'axios'
import store from '@/store'
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'Team',
  metaInfo () {
    return {
      title: this.$parent.getMetaTitle('Wir.Team'),
      meta: [
        { name: 'description', content: this.$parent.getDescription('Wir.Team') },
        { property: 'og:title', content: this.$parent.getOGTitle('Wir.Team') },
        { property: 'og:description', content: this.$parent.getOGDescription('Wir.Team') }
      ]
    }
  },
  data: function () {
    return {
      employees: {},
      events: [],
      index: null,
      singleViewOn: false
    }
  },
  computed: {
    e_id: function () {
      return this.$route.params.id
    },
    event_images () {
      var iarray = []
      this.events.forEach(function (i) {
        iarray.push(i.image.data.full_url)
      })
      return iarray
    },
    team_content () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Team-Einleitung') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    },
    ito_team_image () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Team-Einleitung') > -1
        })
        return txt.length ? txt[0].image : null
      } else {
        return ''
      }
    }
  },
  methods: {
    hideSingleView: function () {
      this.singleViewOn = false
      this.$router.push({ name: 'ito.team' }).catch(() => {})
    },
    generateThumbnail (asset, w, h, q, f) {
      return 'https://cdn.ito-consult.de' + asset + '?w=' + w + '&h=' + h + '&q=' + q + '&f=' + f
    }

  },
  async beforeMount () {
    await axios.get('/employees?fields=id,firstname,lastname,slug,job,image_avatar.data.full_url,image_avatar_rgb.data.full_url')
      .then(response => {
        this.employees = response.data.data
        store.commit('loadingStatus', false)
      })
    await axios.get('/eventimages?fields=title,image.*')
      .then(response => (this.events = response.data.data))
  },
  components: {
    MainBanner,
    CoolLightBox
  }

}
</script>
<style scoped>
    .event-image {overflow: hidden;}
    .event-image img {filter: grayscale(1); transition: all 1s;}
    .event-image img:hover {filter: grayscale(0); transform: scale(1.1,1.1);}

    #teammembersingle {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        right: 0;
        background: rgba(255,255,255,.95);
        display: block;
        z-index: 1001;
        opacity: 0;
        transform: translate(0,-100%);
        transition: opacity, transform 400ms;
        overflow: auto;
    }

    .teammate {font-size: .9rem;}
    @media(min-width: 992px){
        .teammate {font-size: 1rem;}
    }

    .teammate {
     display: block;
     overflow: hidden;
     position: relative;
     margin-bottom: 1.5rem;
     color: #666; text-decoration: none;
     transform: color 300ms;
 }
 .teammate .image::after {
     content: "";
     position: absolute;
     z-index: 10;
     background: rgba(0,0,0,.7) url('data:image/svg+xml;charset=UTF-8,<svg width="36" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="rgba(255,255,255,.8)" d="M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"></path></svg>');
     background-repeat: no-repeat;
     background-position: center center;
     left: 0;
     right: 0;
     top: 0;
     bottom: 0;
     opacity: 0;
     display: none;
     animation: rotating 2s linear infinite;
     transition: opacity 300ms;
 }
 .teammate.loading .image::after {
    display: block;
    opacity: 1;
 }
 .teammate .image {
    overflow: hidden;
    display: block;
    position: relative;
    width: 100%;
    padding-top: 66.6666%;
 }
 .teammate .image img{
     position: absolute;
     top: 0; left: 0;
     transition: transform 1500ms, opacity 500ms;
 }
.teammate img.img_bw {z-index: 1;}
.teammate img.img_rgb {z-index: 2; opacity: 0}

 .teammate:hover img {
  transform: scale(1.1,1.1);
 }

.teammate:hover img.img_rgb {
   opacity: 1;
 }

 .teammate:hover {
     color: #333;
 }

 #teammembersingle.focus {
  opacity: 1;
  transform: translate(0,0);
 }
</style>
